var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_c('b-jumbotron',{attrs:{"header":"Messages","lead":"Messages Application for you","id":"last-version-jumbo"}})],1),_c('wtForm',[_c('template',{slot:"left"}),_c('template',{slot:"right"})],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }